function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.6581988mm",
    height: "7.5410161mm",
    viewBox: "0 0 2.6581988 7.5410161",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.8624639,-58.190016)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 8.2706714,65.261307 q -0.2050782,0.112304 -0.390625,0.166015 -0.1806641,0.05371 -0.3466797,0.05371 -0.2832031,0 -0.3857422,-0.12207 -0.097656,-0.126953 -0.097656,-0.517578 0,-0.229492 0.053711,-1.655274 0.058594,-1.430664 0.058594,-2.636718 0,-0.361328 -0.00977,-0.644532 -0.00977,-0.288085 -0.029297,-0.52246 l -0.1464843,0.05859 q -0.5273438,0.219727 -0.6152344,0.219727 -0.1220703,0 -0.1855469,-0.07324 -0.063477,-0.07813 -0.063477,-0.22461 0,-0.09766 0.024414,-0.219726 0.029297,-0.122071 0.083008,-0.268555 0.4394531,-0.09277 0.9716797,-0.263672 0.5322266,-0.170898 0.6494141,-0.170898 0.1708984,0 0.234375,0.102539 0.068359,0.102539 0.068359,0.390625 0,0.07813 -0.029297,0.449219 -0.1123047,1.665039 -0.1123047,3.237304 0,1.259766 0.058594,1.816406 0.063477,0.551758 0.209961,0.825196 z",
    style: {
      fontSize: 10,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit1);
export default __webpack_public_path__ + "static/media/digit-1.648cfb7b1931229fe9e725a81c78bd9a.svg";
export { ForwardRef as ReactComponent };